













































































































































































































































































































































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import FormFieldRadioButton from '@ui/FormBuilder/FormFields/FormFieldRadioButton'

settings =
  name: "FormProductSampling"
  vue:
    props: ['activation', 'wizard']

    components: {
      FormFieldRadioButton,
    }

    data: ->
      shippingPreference: @initializeShippingPreference()
      displayProductProfile: null

    computed:
      shippingProfile: -> @wizard.campaignData.shipping_profile || {}
      productProfile: -> @wizard.campaignData.product_profile || {}
      providingFood: -> !!@activation.distributing.food
      providingDrink: -> !!@activation.distributing.drink
      providingOtherCpg: -> !!@activation.distributing.other_cpg
      providingPromo: -> !!@activation.distributing.promo
      providingFoodOrDrinkOrOtherCpg: -> @providingFood or @providingDrink or @providingOtherCpg

      configPricingTable: -> @wizard.partnerBuy?.config?.partner_pricing_table || @standardPricingTable()

      formattedFoodSingleServingPrice: -> @$options.filters.formatMoney((@configPricingTable.food_distribution?.price_in_cents || 50) / 100)
      formattedFoodMultiServingPrice: -> @$options.filters.formatMoney((@configPricingTable.food_multi_serving_distribution?.price_in_cents || 50) / 100)

      foodPrice: ->
        model = 'food_multi_serving_distribution' if 'multiple_servings' is @activation.food.serving_size
        model ||= 'food_distribution'
        parseFloat(@configPricingTable[model]?.price_in_cents || 50) / 100

      drinkPrice: -> parseFloat(@configPricingTable.drink_distribution?.price_in_cents || 60) / 100
      otherCpgPrice: -> parseFloat(@configPricingTable.other_cpg_distribution?.price_in_cents || 60) / 100
      promoPrice: ->
        model = 'addon_promo_distribution' if @providingFoodOrDrinkOrOtherCpg
        model ||= 'promo_distribution'
        parseFloat(@configPricingTable[model]?.price_in_cents || 50) / 100
      assemblyAddonPrice: -> parseFloat(@configPricingTable.addon_assembly?.price_in_cents || 50) / 100
      serveColdAddonPrice: -> parseFloat(@configPricingTable.addon_serve_cold?.price_in_cents || 25) / 100

      consumable: ->
        c = 'food' if @providingFood
        c = 'drink' if @providingDrink
        c = 'CPG' if @providingOtherCpg
        c = 'food / drink' if @providingFood and @providingDrink
        c
      consumablePromoItems: ->
        return "#{@consumable} items" if @activation.promo.distribution_ratio > 1
        return "#{@consumable} item"

      storageOptions: ->
        options = [
          # { label: 'None', value: '', disabled: false }
          { label: 'Standard Storage', value: 'storage_available', disabled: false }
          # { label: 'Keep Out of Direct Sunlight', value: 'storage_out_of_sunlight_available', disabled: false }
          { label: 'Climate Controlled Storage', value: 'climate_controlled_storage_available', disabled: false }
          { label: 'Cold Storage', value: 'cold_storage_available', disabled: false }
          { label: 'Frozen Storage', value: 'frozen_storage_available', disabled: false }
        ]
        return options unless @configEnabledStorages.length
        options.map((storage) =>
          storage.disabled = true if storage.value.length && !@configEnabledStorages.includes storage.value
          storage
        )

      optionsForShippingPreference: ->
        [
          { value: 'cases', label: 'Cases' }
          { value: 'pallets', label: 'Pallets' }
          { value: 'items', label: 'Items' }
        ]

      partnerBuyConfig: -> @wizard.partnerBuy?.config || {}
      isAssemblyDisabled: ->
        return false unless @wizard.partnerBuy?.config?
        !@partnerBuyConfig?.sampling_services?.can_assemble_items
      isServeColdDisabled: ->
        return false unless @wizard.partnerBuy?.config?
        !@partnerBuyConfig?.sampling_services?.can_serve_cold
      configEnabledStorages: -> @partnerBuyConfig?.storage || []

      showOmnichannel: ->
        @showOmnichannelSignage || @showOmnichannelDigital || @showOmnichannelSocial
      showOmnichannelSignage: ->
        return true unless @isPartnerBuy()
        !!@wizard.audienceListingData?.omnichannel?.signage?.enabled
      showOmnichannelDigital: ->
        return true unless @isPartnerBuy()
        !!@wizard.audienceListingData?.omnichannel?.digital?.enabled
      showOmnichannelSocial: ->
        return true unless @isPartnerBuy()
        !!@wizard.audienceListingData?.omnichannel?.social?.enabled

    methods:
      initializeShippingPreference: ->
        { shipping_preference } = @wizard.campaignData.shipping_profile || {}
        preference = 'pallets' if shipping_preference.includes 'pallets'
        preference ||= shipping_preference
        preference ||= 'items'
        preference

      hiSetShippingPreference: (value) ->
        @setShippingPreference value
      setShippingPreference: (value) ->
        { partial_pallet, cases } = @shippingProfile.overflow

        if value is 'pallets'
          preference = 'full_pallets'
          preference = 'pallets_and_cases' if cases
          preference = 'pallets_partial' if partial_pallet

        preference ||= value
        @shippingProfile.shipping_preference = preference

      storageLabel: (storage) ->
        return storage.label unless storage.disabled
        "#{storage.label} (unavailable)"

    watch:
      providingFood: -> @wizard.clearError('product_sampling_distribution')
      providingDrink: -> @wizard.clearError('product_sampling_distribution')
      providingOtherCpg: -> @wizard.clearError('product_sampling_distribution')
      providingPromo: -> @wizard.clearError('product_sampling_distribution')

      providingFood: (providingFood) ->
        if providingFood
          @activation.food.serving_size ||= 'single_serving'
        else
          @activation.food.serving_size = null

      providingFoodOrDrinkOrOtherCpg: (providingFoodOrDrinkOrOtherCpg) ->
        @activation.supplier_provisions.serve_cold = false unless providingFoodOrDrinkOrOtherCpg

export default VueOptions.vue settings
